import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { Table, TableName } from '@openx/components-table/Table';
import { useTranslation } from 'react-i18next';
import { useDealInsightsContext } from '../../../../context/DealInsightsContext';
import { NoDataComponent } from '../../../shared/NoDataComponent';
import { useDeliveryByAdSizeTableColumns } from './hooks/useDeliveryByAdSizeTableColumns';
import { useDeliveryByAdSizeTableData } from './hooks/useDeliveryByAdSizeTableData';

export const DeliveryByAdSizeTable = () => {
  const { dealInsights, criteria, handleCriteriaChange } = useDealInsightsContext();
  const { data: rawData } = dealInsights;
  const { t } = useTranslation();
  const theme = useTheme();
  const { data, isLoading } = useDeliveryByAdSizeTableData();

  const { columns } = useDeliveryByAdSizeTableColumns({
    impressions: {
      max: rawData?.delivery_by_ad_size.impressions_range.maximum ?? 0,
      min: rawData?.delivery_by_ad_size.impressions_range.minimum ?? 0,
      color: theme.palette.charts.indigo,
    },
    spend: {
      max: rawData?.delivery_by_ad_size.spend_range.maximum ?? 0,
      min: rawData?.delivery_by_ad_size.spend_range.minimum ?? 0,
      color: theme.palette.charts.lightBlue,
    },
    sov: {
      max: rawData?.delivery_by_ad_size.sov_range.maximum ?? 0,
      min: rawData?.delivery_by_ad_size.sov_range.minimum ?? 0,
      color: theme.palette.charts.purple,
    },
    viewability: {
      max: 1,
      min: 0,
      color: theme.palette.charts.pink,
    },
    ecpm: {
      max: rawData?.delivery_by_ad_size.ecpm_range.maximum ?? 0,
      min: rawData?.delivery_by_ad_size.ecpm_range.minimum ?? 0,
      color: theme.palette.charts.blue,
    },
    ctr: {
      max: rawData?.delivery_by_ad_size.ctr_range.maximum ?? 0,
      min: rawData?.delivery_by_ad_size.ctr_range.minimum ?? 0,
      color: theme.palette.charts.canary,
    },
  });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box
        sx={{
          px: 4,
          pt: 4,
          pb: 1,
          borderBottom: theme => `1px solid ${theme.palette.divider}`,
        }}
      >
        <Typography variant="h2">{t('Delivery by Ad Size [Banner Only]')}</Typography>
      </Box>

      <Table
        data-test="deal-insights-delivery-by-ad-size-table"
        data={data}
        columns={columns}
        loading={isLoading}
        criteria={criteria[TableName.DEAL_INSIGHTS_DELIVERY_BY_AD_SIZE]}
        name={TableName.DEAL_INSIGHTS_DELIVERY_BY_AD_SIZE}
        onCriteriaChange={newCriteria => handleCriteriaChange(newCriteria, TableName.DEAL_INSIGHTS_DELIVERY_BY_AD_SIZE)}
        overrideTableCellStyles={{ padding: 0 }}
        skeletonRows={10}
        customNoDataComponent={NoDataComponent}
        stickyActionColumn
      />
    </Box>
  );
};
